import Backbone from 'backbone'
import template from './briefings-edit.hbs'
import EditForm from 'scoreboard/components/edit/edit-form'
import _ from 'lodash'
import DraggableList from 'draggable-list'
import briefingsEditSlideRow from './briefings-edit-slide-row.hbs'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import $ from 'jquery'
import iconForObject from 'scoreboard/components/icon-for-object'
import conductor from 'scoreboard/components/conductor'
import briefer from './briefer'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import appDisplay from 'scoreboard/components/app-display'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import EmptyState from 'scoreboard/components/empty-state'
import noSlides from './no-slides.hbs'
import Slide from './slide'
import WebAddressForm from 'scoreboard/components/web-address-form'
import Tooltip from 'scoreboard/components/tooltip'
import i18n from 'scoreboard/components/i18n'
import YouTubeVideo from 'scoreboard/home/you-tube-video'
import httpsValidator from 'scoreboard/components/validators/https-validator'
import url from 'scoreboard/components/url'
import constants from 'scoreboard/components/constants'
import highlight from 'scoreboard/components/highlight'
import { triggerAddOrEdit } from 'scoreboard/components/domain-object-events'

var BriefingForm = Backbone.View.extend({

	// this.model is a Briefing

	className: 'briefings-edit table-hack display-layout',

	events: {
		'click .edit-slide': 'onEditSlide',
		'click .delete-slide': 'deleteSlide',
		'click .add-item.web-address': 'onWebSlide',
		'click .cancel': 'cancel'
	},

	initialize: function() {
		// #30209 make delete confirmation messages clearer for entire briefing
		let substitution = highlight(_.get(this.model.attributes, 'label'))
		let confirmDeleteMessage =
			i18n.get('briefingBooks.briefing.delete.confirmation', substitution)

		if (this.model.isNew()) {
			this.model.set('label', i18n.get('briefingBooks.briefingBook.new'))
		}
		this.editForm = new EditForm({
			model: this.model,
			section: 'briefings',
			confirmDeleteMessage
		})

		this.formView = new FormView({
			toggleCancel: true,
			el: this.el,
			submit: this.submit.bind(this),
			// #43166 the name is pre-populated, so allow saving if the briefing
			// is new
			// #55024 If modifying an existing briefing, then don't allow saving
			// until there is some modification
			allowCleanSubmission: this.model.isNew()
		})
		this.formView.on('change', this._change.bind(this))
	},

	_change: function() {
		this.trigger('change', formHelper.readFromDom(this.el))
	},

	render: function() {
		this.removeChildren()
		// NOTE: there is NOT supposed to be a display-header here!
		this.$el.empty().append(template(this.context()))

		// change the first tab (whichever it is) to point at the briefings overview
		this.$('.tabs .tab').eq(0).find('a')
			.attr('href', 'briefings/' + this.model.id)

		this.$('.slides.panel').before(this.editForm.el)
		this.editForm.render()
		if (this.model.isNew()) {
			// cancel button should always be available so we can escape out of
			//creating the briefing
			this.$('.cancel').prop('disabled', false)
			this.$('[name=label]').select()
		} else {
			this.renderSlides()
		}

		this.formView.start({
			isNew: this.model.isNew()
		})

		// In order to stop the draggable list drag feature from interrupting
		// a click to .delete-slide, capture the clicks/touches here and handle them accordingly.
		var checkDragging = function(e) {
			if (e.target.classList.contains('button')) {
				e.preventDefault()
				e.stopPropagation()
			}
		}
		this.$('.delete-slide').on('mousedown', e => checkDragging(e))
		this.$('.delete-slide').on('touchstart', e => checkDragging(e))
		this.$('.delete-slide').on('touchend', e => this.deleteSlide(e))

		return this
	},

	refresh: function() {
		this.$('.num-slides').text(this.model.slides().length)
	},

	context: function() {
		var c = this.model.toJSON()
		// make sure if the slides property is null, we still have 0 displayed
		// as the number of slides
		c.slides = c.slides || []
		return c
	},

	renderSlides: function() {
		this.$('.panel.slides').removeClass('is-not-displayed')
		var slides = _.map(this.model.get('slides'), function(slide) {
			return _.extend({ icon: iconForObject(slide, 'slide-or-page') }, slide)
		})
		const noSlides = _.isEmpty(slides)
		var html = ''
		_.each(slides, slide => html += this.getSlideHtml(slide))
		this.$('ul.slides').html(html)

		this.$('.no-slides').toggleClass('is-not-displayed', !noSlides)
		this.$('ul.slides').toggleClass('is-not-displayed', noSlides)

		this.draggableList = new DraggableList(this.$('ul.slides')[0])
		this.draggableList.on('move', this.reorderSlide.bind(this))
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
	},

	getSlideHtml: function(slide) {
		const isExternalUrl = !httpsValidator(slide.url)
		const subLabels = this.model.get('subLabels')
		let subLabel = url.hostname(slide.url)
		if (!isExternalUrl) {
			const id = conductor.id(slide.url)
			const section = conductor.section(slide.url)
			subLabel = _.get(subLabels,`[${section}][${id}]`,'')
		}
		return briefingsEditSlideRow(_.extend({}, slide, {
			iconClass: 'icon-' + slide.icon,
			subLabel,
			editable: isExternalUrl
		}))
	},

	reorderSlide: function(node, newIndex, oldIndex) {
		var slideId = this.$(node).data('id')
		$.ajax({
			method: 'post',
			url: 'api/briefings/' + this.model.id + '/slides/' + slideId + '/reorder?index=' + newIndex,
			success: function(slides) {
				this.model.set('slides', slides)
				this.model.trigger('reoder:slides')
			}.bind(this)
		})
	},

	onWebSlide: function(e) {
		this._launchWebAddressTooltip((label, url) => {
			const slide = new Slide({briefingId: this.model.id, label, url})
			slide.save(slide.attributes, {
				success: () => {
					Backbone.trigger('add:domain-object', slide)
					this.renderSlides()
					this.refresh()
					this.webSlideTooltip.remove()
				}
			})
		}, {
			attachTo: e.target,
			header: i18n.get('common.add2', i18n.get('briefingBooks.slide.web'))
		})
	},

	onEditSlide: function(e) {
		const slide = this._getTargetSlide(e)
		this._launchWebAddressTooltip((label, url) => {
			slide.set('label', label)
			slide.set('url', url)
			slide.save(slide.attributes, {
				patch: true,
				success: () => {
					Backbone.trigger('edit:domain-object', slide)
					const s = slide.attributes
					const ctx = _.extend({ icon: iconForObject(s, 'briefings') }, s)
					$(e.target).closest('li[data-id]')
						.replaceWith(this.getSlideHtml(ctx))
					this.webSlideTooltip.remove()
				}
			})
		},{
			attachTo: e.target,
			header: i18n.get('common.edit2', i18n.get('briefingBooks.slide.web')),
			label: slide.get('label'),
			url: slide.get('url')
		})
	},

	_launchWebAddressTooltip: function(onSaveFn, options={}) {
		const {header, label, url} = options
		const webAddressForm = new WebAddressForm({
			header,
			label,
			url,
			primaryButtonLabel: i18n.get('common.save'),
			httpsValidator: true
		})

		this.webSlideTooltip = new Tooltip({
			attachTo: options.attachTo,
			content: webAddressForm,
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu'
		}).render()

		webAddressForm.on('cancel', () => this.webSlideTooltip.remove())
		webAddressForm.on('submit', this._saveWebAddress.bind(this, onSaveFn, webAddressForm))

		return webAddressForm
	},

	_saveWebAddress: function(onSaveFn, webAddressForm, {label, url}) {
		// Youtube is tricky, so let's help users out if they want to embed a video
		url = transformYouTubeUrl(url)
		$.get({
			url: 'api/embedded-content/validate?' + $.param({url}),
			success: () => onSaveFn(label, url),
			error: response => {
				webAddressForm.formView.errorMessage(response.responseJSON.message)
			}
		})
	},

	submit: function(e) {
		// record this now, because it will always be false inside the success callback
		var action = this.model.isNew() ? 'add' : 'edit'
		return this.model.save({ label: this.$('[name=label]').val() }, {
			patch: true,
			success: function(model) {
				this.trigger('save', model)
				triggerAddOrEdit(action, model)

				if (action === 'add') {
					// must go before return statement
					briefer.show(model, null, constants.BRIEFING_MODE_IS_VIEWING_SLIDE)
					appDisplay.display( new EmptyState({ body: noSlides() }).render().el )
					conductor.navigate('briefings/' + model.id)
				} else {
					this.$('.slides').show()
					briefer.show(model, null, constants.BRIEFING_MODE_IS_EDITING_BRIEFING)

					this.formView.start({ isNew: false })
				}
			}.bind(this)
		})
	},

	deleteSlide: function(e) {
		const slide = this._getTargetSlide(e)
		// #30209 specific delete confirmation message for slides
		let substitution = highlight(_.get(slide.attributes, 'label'))
		let message = i18n.get('briefingBooks.slide.delete.confirmation', substitution)
		var confirmation = new DeleteConfirmation({message})
		appDisplay.dialog(confirmation)
		confirmation.once('confirm', function() {
			var model = this.model.slides().remove(slide)
			model.destroy().then(function() {
				confirmation.trigger('done')
				$(e.target).closest('li[data-id]').remove()
				Backbone.trigger('delete:domain-object', model)
				this.refresh()
			}.bind(this))
		}.bind(this))
	},

	_getTargetSlide: function(e) {
		var row = $(e.target).closest('li[data-id]')
		var slideId = row.data('id')
		return this.model.slides().get(slideId)
	},

	cancel: function() {
		if (this.model.isNew()) {
			if (this.model.get('parentId') || conductor.id()) {
				conductor.edit()
			} else {
				var url = 'organizations/' + this.model.get('organizationId') + '/briefings'
				conductor.navigate(url, { trigger: true })
			}
		} else {
			this.editForm.labelField.clearError()
			this.editForm.render()
			this.formView.start({
				isNew: this.model.isNew()
			})
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeChildren()
		_.result(this.formView, 'remove')
	},

	removeChildren: function() {
		_.invokeMap([this.editForm, this.draggableList,
			this.covertButtonTooltips, this.webSlideTooltip], 'remove')
		_.invokeMap(formHelper.getMarkedFields(this.el), 'remove')
	}
})

function transformYouTubeUrl(url) {
	if (_.includes(url, 'youtube.com')) {
		return YouTubeVideo.buildUrl(YouTubeVideo.getIdFromUrl(url), {autoplay:false})
	}
	return url
}

export default BriefingForm

BriefingForm.__filename__ = 'briefings/briefings-edit.js'
